import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import { withNamespaces } from 'react-i18next'
import ReactResizeDetector from 'react-resize-detector'

import VirtualizedList from '../../components/Dashboard/VirtualizedInteractionsList'
import Preloader from '../../components/UI/Preloader'

import { fetchInteractions } from '../../ducks/interactions'
import { fetchInteraction } from '../../ducks/interaction'

const Wrapper = styled.div`
  margin-right: 20px;
  max-height: ${(props) => props.height}px;
  background-color: #fff;

  @media (max-width: 992px) {
    width: 100%;
    margin-right: 0;
  }

  ${(props) =>
    props.width === 688 &&
    css`
      background-color: #fff;
      padding: 0;
    `}

  border: 1px solid #eeeff1;
  border-radius: 4px;

  & > div {
    outline: none;
  }
`

const StyledError = styled.div`
  background-color: #fff;
  padding: 18px;
  flex: 1;
  height: ${(props) => props.height}px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
`

class InteractionsList extends Component {
  state = {
    containerWidth: 500,
    entitiesList: []
  }

  onResize = (containerWidth) => {
    this.setState({ containerWidth })
  }

  componentDidUpdate(prevProps) {
    const { onlyWorkRequestsApproval } = this.props.states
    const { entities } = this.props.interactions
    if (
      prevProps.interactions.entities === entities &&
      prevProps.states.onlyWorkRequestsApproval === onlyWorkRequestsApproval
    )
      return

    if (!entities || entities.length === 0) return
    if (!onlyWorkRequestsApproval) {
      this.setState({ entitiesList: entities })
    } else {
      this.setState({
        entitiesList: entities.filter((entity) => entity.hasActiveWR)
      })
    }
  }

  render() {
    const { interaction, interactions, ui, containerHeight, t } = this.props
    const { entities, loading, isMoreToLoad, scrollToTop } = interactions
    const { selectedInteractionId } = interaction

    const { width } = ui.sizes.app

    if (width < 992 && selectedInteractionId) {
      return null
    }

    const calculatedWidth = width < 992 ? this.state.containerWidth : 364

    if (!loading && entities.length === 0) {
      return (
        <StyledError height={containerHeight} width={width}>
          {t('tickets:noTickets')}
        </StyledError>
      )
    }

    return (
      <Wrapper height={containerHeight} width={calculatedWidth}>
        {loading && <Preloader />}

        <ReactResizeDetector handleWidth onResize={this.onResize} />
        {this.state.entitiesList.length !== 0 && (
          <VirtualizedList
            width={calculatedWidth}
            height={containerHeight}
            entities={this.state.entitiesList}
            isMoreToLoad={isMoreToLoad}
            fetchInteractions={this.props.fetchInteractions}
            fetchInteraction={this.props.fetchInteraction}
            loading={loading}
            scrollToTop={scrollToTop}
          />
        )}
      </Wrapper>
    )
  }
}

export default compose(
  connect(
    ({ interaction, interactions, ui, states, profile }) => ({
      interaction,
      interactions,
      ui,
      states,
      profile
    }),
    { fetchInteractions, fetchInteraction }
  ),
  withNamespaces()
)(InteractionsList)
